import compose from 'react-hooks-compose'

import { useCardAuthenticationWithFieldsLogic } from './useCardAuthenticationWithFieldsLogic'
import { CardAuthenticationWithFieldsPresenter } from './presenter'

export const CardAuthenticationWithFields = compose(props => ({
	useLogic: () => useCardAuthenticationWithFieldsLogic(props),
}))(CardAuthenticationWithFieldsPresenter)
